import { useContext } from "react";
import {
  ManageWorkspaceAdminDialogContext,
  ManageWorkspaceAdminContextType,
} from "./ManageWorkspaceAdminContext";

export const useManageWorkspaceAdminDialog =
  (): ManageWorkspaceAdminContextType => {
    const context = useContext(ManageWorkspaceAdminDialogContext);
    if (!context) {
      throw new Error(
        "useManageWorkspaceAdminDialog must be used within a ManageWorkspaceAdminProvider"
      );
    }
    return context;
  };
